// FAQ URL path helper functions
// Uses hash-based routing (#/topic/article) so deep links work without server-side routing

// Slug used for articles without a topic
export const MISC_TOPIC_SLUG = 'misc';

/**
 * Get the current page base path (URL without hash)
 * @returns {string} Base URL without hash
 */
export function getPagePath() {
  const url = new URL(window.location.href);
  url.hash = '';
  return url.toString();
}

/**
 * Build URL path for a specific article
 * @param {string} topicSlug - The topic slug (null will use MISC_TOPIC_SLUG)
 * @param {string} articleSlug - The article slug
 * @returns {string} Full URL for the article
 */
export function buildArticlePath(topicSlug, articleSlug) {
  const url = new URL(window.location.href);
  const effectiveTopicSlug = topicSlug || MISC_TOPIC_SLUG;
  url.hash = `#/${effectiveTopicSlug}/${articleSlug}`;
  return url.toString();
}

/**
 * Build URL path for a specific topic (shows all articles in that topic)
 * @param {string} topicSlug - The topic slug (null will use MISC_TOPIC_SLUG)
 * @returns {string} Full URL for the topic
 */
export function buildTopicPath(topicSlug) {
  const url = new URL(window.location.href);
  const effectiveTopicSlug = topicSlug || MISC_TOPIC_SLUG;
  url.hash = `#/${effectiveTopicSlug}`;
  return url.toString();
}

/**
 * Check if the current URL contains FAQ hash segments
 * @returns {boolean} True if URL contains hash path
 */
export function pathContainsFaqPath() {
  return window.location && window.location.hash && window.location.hash.length > 1;
}

/**
 * Parse the current URL hash to extract topic and article slugs
 * @returns {Object} Object containing topicSlug and articleSlug (both strings or null)
 */
export function parseFaqPath() {
  if (!pathContainsFaqPath()) {
    return { topicSlug: null, articleSlug: null };
  }

  // Remove the leading # and optional /
  const hash = window.location.hash.replace(/^#\/?/, '');
  const segments = hash.split('/').filter(s => s.length > 0);

  return {
    topicSlug: segments[0] || null,
    articleSlug: segments[1] || null
  };
}

/**
 * Navigate to a URL using hash change (for client-side navigation)
 * @param {string} url - The URL to navigate to
 */
export function navigateToUrl(url) {
  // Extract hash from URL and set it
  const urlObj = new URL(url);
  window.location.hash = urlObj.hash;
}
